/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {avatarPath} from '../../../helpers'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  const [avatar, setAvatar] = useState('')

  useEffect(() => {
    setAvatar(avatarPath(currentUser?.avatar_url, currentUser?.avatar))
  }, [currentUser])

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-auto'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt={currentUser?.name} src={avatar} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.name}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>Admin</span>
            </div>
            <a
              href={`mailto://${currentUser?.email}`}
              className='fw-bold text-muted text-hover-primary fs-7'
            >
              {currentUser?.email}
            </a>
          </div>
        </div>
      </div>

      <div className='menu-item px-5 my-1'>
        <Link to='/cmb/account/settings' className='menu-link px-5'>
          Preferências do Usuário
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sair
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
